import React, {
  useState,
  useEffect,
  useCallback,
  useRef,
  memo,
  SyntheticEvent,
} from 'react';
import styled from 'styled-components';
import cn from 'classnames';

// export const placeholder =
// 'data:image/png;base64,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';

// export const placeholder =
//   'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHUAAAB1CAMAAABH2l6OAAAAn1BMVEUAAAD09PT09PT09PT09PT19fX09PT////09PT19fX09PT19fX09PT19fXz8/P29vbx8fH09PT19fX09PT09PT09PT09PT19fX09PT09PT09PT19fX29vb09PT09PT09PT19fXy8vL////19fX09PT09PT09PT////09PTz8/P19fX09PT19fX19fXz8/P09PT09PT09PTz8/P09PT09PRbaPU6AAAANHRSTlMA3e/8zPW8A/kZ6mgMqpogEdbfuJZ3XEikiHNNNJ5TRC8mCOOPbjoGxUCuintiKtHBV4Kzje5npQAAA3pJREFUaN7N2tdy4kAQheGDIgpIAkTOwQSTjN3v/2yLd7EWgxptwfR4v2uovxAUo54RZMTvllGevTZd6OO+2/RHaQFdwg/KlIfQI1nRBXsMHbwDffMGDeIaXRlD3GRG17aQtr+NUhvC+j7deoWsvkE5UohaGJRnB0kjm/KUPQhq2ZRrDkHDMuWqJpDTNCnXLIacHROtTSAn4KIx5HQpX9WDnMZPRN9/IjpnoocEclImaglG3cFPRNtMdBVCzPKVib79RLQ+hZjQ+Z+iH0uISSwmWsmiXpBW0pdYR7Ttfr0iKtMns+1BEa/KRAdf0XGJvvgL4WiURX36y5hAgbjERFPmHnWlYqqoMdE5e4/aUj7KZDZslCI8aewz0XecrW26dlA8VWS29+7GfYGpIouyd+MlPGNtM9EXnPXKlMMRGGUKo9QVGGUoKJg7DA+P4T8HmU2cHU3mUqifn8xj0bAzwMOOTLQ8LBp22u7jUbMoGqiPNrlorygauconRXuURSlf+ng0KIx2Sfn+QEBMdF001m3Uj6fGoijaEYj2i2bJLR7mlSmXP8ZZh0j5n2/MRPdFA+wLnlETjPKiuzs6KbsMPad3Z0fHHbDL0JPCMnP1RKKZOl1rMaO6yuOUJvNZlxV2RVAgNOiK7wGYMqO63YISEd1kg/XuwK4IauyJIRLNOP8eXUOZFjGYZUgR6x+jfag0UhAV+mb9MRTrU6HZBMoNiCF6sJD4BdEYEpriUX7p0b7H7/nEKXkQ0yPOCII2xHAhaGkxVQ+SYp9yvU4hqW8zP6c1JLVMymVGIQS9EKPag6ANcZwxGKJZs72HmAbxnB6kbOmO1S6EjK5Jd9jtlgsJPYPuKg0hYVKluwyICD/ongGEBDYxRE99Y4f4U19BgUF5nBCiko7NnPrKitvm9WK7hAZxx7g59dUh6VZvDmC1WEQ+swktyx2lvtmAfq738DtXzhTa9YkiCOJX7B10WzHPN4tKTOYpQlFDDU9M8luGzhIa1WQXDn6fUn+2SxfZEJrU6YLlQYupTZdqe8jhd2SNNTSY0xU7hLwqfWOuutDAvCham1YILQ70x2HeS6BNf0Y0q8+7QaPR6aTRoHLinLxZn0oFrE9vp5fXKyeDKO10Go0gOA7X4wT3TI/NZtDYdjZRdOqdc9XSiZGx6YqR8UsnVevkd7t9DjdbE3zzC+8Ji0DhgS54AAAAAElFTkSuQmCC';

export const PLACEHOLDER = '/assets/default.png';
const Image = styled.img`
  &.has-error {
    // fallback to placeholder image on error
    content: url(${PLACEHOLDER});
  }
`;

export type Props = {
  [key: string]: any;
};

export const LazyImage = memo<Props>((props) => {
  const {
    src,
    className: classNameProp,
    placeholder: placeholderProp,
    loadedClassName = '',
    srcSet = null,
    ...rest
  } = props;
  const placeholder = placeholderProp || PLACEHOLDER;
  const [imageSrc, setImageSrc] = useState(placeholder);
  const [imageSrcSet, setImageSrcSet] = useState(null);
  const imageRef = useRef();
  const [isError, setIsError] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);

  const onLoad = useCallback((event) => {}, []);

  const onError = useCallback((event: SyntheticEvent) => {
    setIsError(true);
    // event.target.classList.add('has-error');
  }, []);

  useEffect(() => {
    let observer;
    let didCancel = false;

    if (imageRef && imageSrc !== src) {
      if (IntersectionObserver) {
        observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (
                !didCancel &&
                (entry.intersectionRatio > 0 || entry.isIntersecting)
              ) {
                setImageSrc(src);
                setImageSrcSet(srcSet);
                observer.unobserve(imageRef?.current);
              }
            });
          },
          {
            threshold: 0.01,
            rootMargin: '75%',
          }
        );
        observer.observe(imageRef?.current);
      } else {
        // Old browsers fallback
        setImageSrc(src);
        setImageSrcSet(srcSet);
      }
    }
    return () => {
      didCancel = true;
      // on component cleanup, we remove the listener
      if (observer && observer.unobserve) {
        observer.unobserve(imageRef?.current);
      }
    };
  }, [src, imageSrc, imageRef]);

  const imageProps = isError
    ? {
        src: placeholder,
      }
    : {
        src: imageSrc,
        srcSet: imageSrcSet,
      };
  const className = cn(classNameProp, {
    [loadedClassName]: isLoaded,
  });

  return (
    <Image
      {...rest}
      {...imageProps}
      className={className}
      ref={imageRef}
      onLoad={onLoad}
      onError={onError}
    />
  );
});
LazyImage.displayName = 'LazyImage';

export default LazyImage;
